export const REASON_REJECT_TRANSACTION_TRADE = {
  BUYER_COSTS_LIST_REJECTION: 'buyer_costs_list_rejection',
  BUYER_PRICE_REJECTION: 'buyer_price_rejection',
  BUYER_TRADE_CANCELLATION: 'buyer_trade_cancellation',
  SELLER_REQUEST_REJECTION: 'seller_request_rejection',
  SELLER_TRADE_CANCELLATION: 'seller_trade_cancellation'
}
